import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import styles from './ModalAlert.module.css';

/**
 * Modal Alert Component
 * Shows alerts inside modal windows with auto-dismiss and manual close
 */
const ModalAlert = ({ alert, onClose, autoHideDuration = 5000 }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        if (alert) {
            setIsVisible(true);
            setIsClosing(false);

            // Auto-hide after specified duration
            if (autoHideDuration > 0) {
                const timer = setTimeout(() => {
                    handleClose();
                }, autoHideDuration);

                return () => clearTimeout(timer);
            }
        } else {
            setIsVisible(false);
        }
    }, [alert, autoHideDuration]);

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setIsVisible(false);
            if (onClose) {
                onClose();
            }
        }, 300); // Match animation duration
    };

    if (!alert || !isVisible) return null;

    const getAlertTypeClass = () => {
        if (alert.type === 'error') return styles.error;
        if (alert.type === 'warning' || alert.type === 'alert') return styles.warning;
        return styles.info;
    };

    return (
        <div className={`${styles.modalAlert} ${getAlertTypeClass()} ${isClosing ? styles.closing : ''}`}>
            <div className={styles.alertContent}>
                <div className={styles.alertIcon}>
                    {alert.icon}
                </div>
                <div className={styles.alertMessage}>
                    {alert.message}
                </div>
                <button
                    className={styles.alertCloseButton}
                    onClick={handleClose}
                    aria-label="Close alert"
                >
                    <FaTimes />
                </button>
            </div>
        </div>
    );
};

export default ModalAlert;